import { defineMessages } from 'react-intl';

const messages = defineMessages({
  thank_text: {
    id: 'YRLPyq',
    defaultMessage: 'Thank you for submitting the form!',
  },
  thank_bp_title: {
    id: 'BkHBGW',
    defaultMessage: 'Selected Business Partner',
  },
  thank_return_assessment: {
    id: 'acrOoz',
    defaultMessage: 'Continue',
  },
  modal_foundCountry: {
    id: 'q0Y/L/',
    defaultMessage: 'Found country',
  },
  modal_accessPageCapitalized: {
    id: 'GjxKEi',
    defaultMessage: 'Access page in',
  },
  modal_availableIn: {
    id: 'O0nJUK',
    defaultMessage: 'The AI Solutions Advisor is available in',
  },
  modal_localCurrency_text: {
    id: '35V5JI',
    defaultMessage: 'with local currency',
  },
  modal_stayHere: {
    id: 'ObupdK',
    defaultMessage: 'Stay here',
  },
  modal_takeMeThere: {
    id: 'GeEQEA',
    defaultMessage: 'Take me there',
  },
  welcome_title: {
    id: 'tg4hLW',
    defaultMessage: 'AI Solutions advisor',
  },
  welcome_subtitle: {
    id: 'TF7AI/',
    defaultMessage: 'to boost employee efficiency',
  },
  welcome_paragraph: {
    id: 'HciF/L',
    defaultMessage:
      'Find the way to implement AI immediately in your enterprise',
  },
  welcome_CTA01: {
    id: 'mOFG3K',
    defaultMessage: 'Start',
  },
  welcome_accessPageCapitalized: {
    id: 'GjxKEi',
    defaultMessage: 'Access page in',
  },
  landingPage_title: {
    id: 'LzmKpB',
    defaultMessage: 'Welcome to AI solutions advisor',
  },
  landingPage_sutitle: {
    id: 's/sP1e',
    defaultMessage:
      "Boost your organization's employee efficiency with the right set of watsonx products, tailored to your needs with estimated prices and potential savings.",
  },
  ladingPage_Step1: {
    id: 'edBt2F',
    defaultMessage: 'Pick your use case',
  },
  ladingPage_Step2: {
    id: 'ljPo6s',
    defaultMessage: 'Uncover package & price',
  },
  ladingPage_Step3: {
    id: 'EPABpF',
    defaultMessage: 'Take next steps',
  },
  ladingPage_subHeading: {
    id: 'dpsepX',
    defaultMessage: 'Where would you like to start today?',
  },
  landingPage_Tile01_Titletext: {
    id: '8FSmC7',
    defaultMessage: 'Employee Experience',
  },
  ladingPage_Tile01_Bodytext: {
    id: 'eaKb4s',
    defaultMessage:
      'Provide your team with self-serve assistant using conversational AI',
  },
  landingPage_Tile02_Titletext: {
    id: '3sOBl2',
    defaultMessage: 'Expert Assist',
  },
  ladingPage_Tile02_Bodytext: {
    id: 'v41hWq',
    defaultMessage:
      'Augments employees with AI Assistant to automate backend processes',
  },
  landingPage_Tile03_Titletext: {
    id: 'lS5MFu',
    defaultMessage: 'Intelligent Document Processing',
  },
  ladingPage_Tile03_Bodytext: {
    id: 'qD6zf5',
    defaultMessage:
      'Enhance compliance and productivity by extracting key document elements efficiently',
  },
  landingPage_Tile04_Titletext: {
    id: 'A95xyj',
    defaultMessage: 'Enterprise Search',
  },
  ladingPage_Tile04_Bodytext: {
    id: 'R+gXJS',
    defaultMessage:
      'Provide accurate answers from diverse sources with traceable enterprise content',
  },
  landingPage_Tile05_Titletext: {
    id: 'C9SkPE',
    defaultMessage: 'Looking for something else?',
  },
  ladingPage_Tile05_Bodytext: {
    id: 'XAwzQY',
    defaultMessage: "Let's talk to reimagine your employee experience",
  },
  employee_experience_title: {
    id: '0Hll63',
    defaultMessage: 'AI solutions advisor for employee experience',
  },
  ee_col1_paragraph_01: {
    id: 'Q0nHXU',
    defaultMessage:
      'Obtain a single conversational UX, by leading IBM and 3rd party LLMs, to:',
  },
  ee_col1_paragraph_02: {
    id: 'xCIOKT',
    defaultMessage: 'Answer policy & procedure FAQs',
  },
  ee_col1_paragraph_03: {
    id: 'b6LFDF',
    defaultMessage:
      'Connect to common self-service applications to perform transactions and trigger automations',
  },
  ee_col1_paragraph_04: {
    id: 'jpC04M',
    defaultMessage: 'Provide personalized answers based on employee role',
  },
  ee_col1_paragraph_05: {
    id: 'sBVGK8',
    defaultMessage: 'Recommended product bundle:',
  },
  ee_col1_paragraph_06_1: {
    id: 'sxfXgq',
    defaultMessage: 'A combinations of ',
  },
  ee_col1_paragraph_06_2: {
    id: 'r4LJFd',
    defaultMessage: 'watsonx Orchestrate, Databases for Elastic',
  },
  ee_col1_paragraph_06_3: {
    id: 'lEaoZ1',
    defaultMessage: ', watsonx.ai',
  },
  ee_col1_tooltip_01_1: {
    id: 'g0DUKZ',
    defaultMessage: 'Databases for Elastic',
  },
  ee_col1_tooltip_01_2: {
    id: 'GRYCkH',
    defaultMessage:
      ' provided fast, scalable data access, enabling quick and accurate responses to user queries.',
  },
  ee_col1_tooltip_02_1: {
    id: 'LPoynT',
    defaultMessage: 'With ',
  },
  ee_col1_tooltip_02_2: {
    id: 'Bqas9k',
    defaultMessage: 'watsonx.ai, ',
  },
  ee_col1_tooltip_02_3: {
    id: 'hWKEJx',
    defaultMessage:
      'responses are personalized based on employee roles, ensuring relevant answers.',
  },
  ee_col2_paragraph_01: {
    id: 'MeQy8/',
    defaultMessage: 'The estimated price for your selection:',
  },
  ee_col2_paragraph_02: {
    id: 'ROMNOB',
    defaultMessage:
      'For less than $3* per month per user, unlock AI Assistants that significantly boost employee productivity by combining Generative AI and automation.',
  },
  ee_col2_paragraph_02_1: {
    id: 'CWsaBD',
    defaultMessage: 'For less than ',
  },
  ee_col2_paragraph_02_2: {
    id: 'ALJP6M',
    defaultMessage: '$3 per month per user',
  },
  ee_col2_paragraph_02_3: {
    id: 'vYXn7i',
    defaultMessage:
      ', unlock AI Assistants that significantly boost employee productivity by combining Generative AI and automation.',
  },
  ee_col2_paragraph_03: {
    id: '8tP6ed',
    defaultMessage: 'Benefits :',
  },
  ee_col2_paragraph_04: {
    id: 'CH5G/O',
    defaultMessage: '70% of employee tasks can be automated',
  },
  ee_col2_paragraph_05: {
    id: 'lnKSrl',
    defaultMessage:
      '40% performance improvement for workers using Generative AI',
  },
  ee_col2_tooltip_01_1: {
    id: 'afi9/u',
    defaultMessage: 'Starting Price offers:',
  },
  ee_col2_tooltip_01_2: {
    id: '/8DR/m',
    defaultMessage:
      'watsonx Orchestrate Essentials Plan 500 Monthly Active User, < 40,000 skill runs',
  },
  ee_col2_tooltip_01_3: {
    id: 'Shfmcl',
    defaultMessage:
      'Databases for Elastic Shared, Small .5 vCPUs, 4GB RAM, 5GB Disk, Enterprise with 5,000 documents watsonx.ai 21M Tokens per year',
  },
  disclaimer: {
    id: 'lI56XZ',
    defaultMessage:
      'Prices shown are illustrative, may vary by country, configuration, and requirements, exclude any applicable taxes and duties, and are subject to product offering availability in a country.',
  },
  ee_col2_tooltip_02: {
    id: 'ijMnA0',
    defaultMessage:
      'McKinsey, The economic potential of generative AI: The next productivity frontier, June 14, 2023',
  },
  ee_col2_tooltip_03: {
    id: 'aP5uF2',
    defaultMessage:
      'MIT Sloan, How generative AI can boost highly skilled workers productivity, Oct 19, 2023',
  },
  ea_col1_paragraph_01: {
    id: 'cLq8nJ',
    defaultMessage:
      'Obtain a single conversational UX, by leading IBM and 3rd party LLMs, that:',
  },
  expert_assist_title: {
    id: 'sF2g4m',
    defaultMessage: 'AI solutions for expert assist',
  },
  ea_col1_paragraph_02: {
    id: 'AIgW4F',
    defaultMessage:
      'Connects to decision and predictive engines, as well as back-end applications',
  },
  ea_col1_paragraph_03: {
    id: 'CzqsqJ',
    defaultMessage:
      'Extracts data from unstructured and semi-structured documents',
  },
  ea_col1_paragraph_04: {
    id: 'aF58yR',
    defaultMessage: 'Augment experts by automating mundane task',
  },
  ea_col1_paragraph_05: {
    id: 'sBVGK8',
    defaultMessage: 'Recommended product bundle:',
  },
  ea_col1_paragraph_06_1: {
    id: 'njwS+W',
    defaultMessage:
      'watsonx Orchestrate (Optionally complement with Databases for Elastic',
  },
  ea_col1_paragraph_06_2: {
    id: 'GPSKd3',
    defaultMessage: ' and wx.ai',
  },
  ea_col1_paragraph_06_3: {
    id: 'sfrx5W',
    defaultMessage: ' - excluded from price displayed)',
  },
  ea_col1_tooltip_01_1: {
    id: 'LAGpLv',
    defaultMessage: 'Databases for Elastic ',
  },
  ea_col1_tooltip_01_2: {
    id: 'jvmTjx',
    defaultMessage:
      ' provide fast, scalable data access, enabling quick and accurate responses to user queries. ',
  },
  ea_col1_tooltip_02_1: {
    id: 'LPoynT',
    defaultMessage: 'With ',
  },
  ea_col1_tooltip_02_2: {
    id: 'MZpQld',
    defaultMessage: 'watsonx.ai',
  },
  ea_col1_tooltip_02_3: {
    id: 'UfyNlt',
    defaultMessage:
      ', responses are personalized based on employee roles, ensuring relevant answers',
  },
  ea_col2_paragraph_01: {
    id: 'MeQy8/',
    defaultMessage: 'The estimated price for your selection:',
  },
  ea_col2_paragraph_02: {
    id: 'P/h3j6',
    defaultMessage:
      'For less than $10* per month per user, you can get started with automating multi-step workflows through a unified natural-language driven interface.',
  },
  ea_col2_paragraph_02_1: {
    id: 'CWsaBD',
    defaultMessage: 'For less than ',
  },
  ea_col2_paragraph_02_2: {
    id: '6g3GFm',
    defaultMessage: '$10 per month per user',
  },
  ea_col2_paragraph_02_3: {
    id: 'Rj+4bP',
    defaultMessage:
      ', you can get  started with automating multi-step workflows through a unified natural-language driven interface',
  },
  ea_col2_paragraph_03: {
    id: '8tP6ed',
    defaultMessage: 'Benefits :',
  },
  ea_col2_paragraph_04: {
    id: 'HWSCiB',
    defaultMessage:
      '30% reduction in time spent searching documents to find information more quickly',
  },
  ea_col2_paragraph_05: {
    id: '2BGYev',
    defaultMessage:
      'Increased knowledge worker learning and satisfaction due to reduced search fatigue and more accurate search result',
  },
  ea_col2_tooltip_01_1: {
    id: 'afi9/u',
    defaultMessage: 'Starting Price offers:',
  },
  ea_col2_tooltip_01_2: {
    id: 'L3VLn6',
    defaultMessage:
      'watsonx Orchestrate Essentials, 20,000 skills, 10 Monthly Active Users, 2000 skill runs/user per month',
  },
  ea_col2_tooltip_02_1: {
    id: 'HUZXwP',
    defaultMessage: 'Forrester, The Total Economic Impact',
  },
  ea_col2_tooltip_02_2: {
    id: 'QBTSuE',
    defaultMessage: 'TM',
  },
  ea_col2_tooltip_02_3: {
    id: 'MfSZoM',
    defaultMessage: ' of IBM Watson Discovery, October 2023',
  },
  intelligent_document_processing_title: {
    id: 'BWXsbU',
    defaultMessage: 'AI solutions advisor for intelligent document processing',
  },
  idc_col1_paragraph_01: {
    id: 'E7XPoT',
    defaultMessage: 'Leverage leading IBM and 3rd party LLMs, to:',
  },
  idc_col1_paragraph_02: {
    id: 'AqLf4F',
    defaultMessage:
      'Identify and classify entities, sentences, and other metadata present in complex documents',
  },
  idc_col1_paragraph_03: {
    id: 'E4ZDVU',
    defaultMessage:
      'Extract insight from single documents and compare them to corporate standards for that document type',
  },
  idc_col1_paragraph_04: {
    id: 'el6I4L',
    defaultMessage:
      'Enable complex document-centric workflow automation by passing relevant data from documents to downstream backed systems',
  },
  idc_col1_paragraph_05: {
    id: 'sBVGK8',
    defaultMessage: 'Recommended product bundle:',
  },
  idc_col1_paragraph_06: {
    id: 'xN/vaQ',
    defaultMessage: 'watsonx Orchestrate and watsonx.ai',
  },
  idc_col1_tooltip_01_1: {
    id: 'LPoynT',
    defaultMessage: 'With ',
  },
  idc_col1_tooltip_01_2: {
    id: 'MZpQld',
    defaultMessage: 'watsonx.ai',
  },
  idc_col1_tooltip_01_3: {
    id: '7lAZ6b',
    defaultMessage:
      ', responses are personalized based on employee roles, ensuring relebant answers',
  },
  idc_col2_paragraph_01: {
    id: 'MeQy8/',
    defaultMessage: 'The estimated price for your selection:',
  },
  idc_col2_paragraph_02: {
    id: '4MFAl3',
    defaultMessage:
      'For less than $10k* per month, you can get started by processing 500 documents and 5000 LLM queries/month.',
  },
  idc_col2_paragraph_02_1: {
    id: 'CWsaBD',
    defaultMessage: 'For less than ',
  },
  idc_col2_paragraph_02_2: {
    id: 'Zpuwui',
    defaultMessage: '$10k per month',
  },
  idc_col2_paragraph_02_3: {
    id: '46saTf',
    defaultMessage:
      ', you can get started by processing 500 documents and 5000 LLM queries/month',
  },
  idc_col2_paragraph_03: {
    id: '8tP6ed',
    defaultMessage: 'Benefits :',
  },
  idc_col2_paragraph_04: {
    id: 'HWSCiB',
    defaultMessage:
      '30% reduction in time spent searching documents to find information more quickly',
  },
  idc_col2_paragraph_05: {
    id: 'XyTyyx',
    defaultMessage:
      'Reduce text analysis/search time by 50% through document understanding and summarization',
  },
  idc_col2_tooltip_01_1: {
    id: 'afi9/u',
    defaultMessage: 'Starting Price offers:',
  },
  idc_col2_tooltip_01_2: {
    id: '2+tpzh',
    defaultMessage:
      'watsonx Orchestrate Standard Plan. 500 Documents processed  per month watsonx.ai 480M+ Tokens per year (60k+LLM queries per year)',
  },
  idc_col2_tooltip_02_1: {
    id: 'HUZXwP',
    defaultMessage: 'Forrester, The Total Economic Impact',
  },
  idc_col2_tooltip_02_2: {
    id: 'QBTSuE',
    defaultMessage: 'TM',
  },
  idc_col2_tooltip_02_3: {
    id: 'MfSZoM',
    defaultMessage: ' of IBM Watson Discovery, October 2023',
  },
  idc_col2_tooltip_03_1: {
    id: 'kk+duB',
    defaultMessage:
      'Forrester, The Economic Impact of IBM Watson Natural Language Processing Solution, February 2021',
  },
  enterprice_search_title: {
    id: 'J1PlvL',
    defaultMessage: 'AI solutions advisor for enterprise search',
  },
  es_col1_paragraph_01: {
    id: 'wEFRS8',
    defaultMessage:
      'Obtain a single search UX for employees, by leading IBM and 3rd party LLMs, to:',
  },
  es_col1_paragraph_02: {
    id: 'hWFCc+',
    defaultMessage:
      'Find accurate and up-to-date information from multiple internal knowledge repositories',
  },
  es_col1_paragraph_03: {
    id: 'Uw0fMs',
    defaultMessage:
      'Normalize content from different formats and repositories into a single UI',
  },
  es_col1_paragraph_04: {
    id: '4jcoyD',
    defaultMessage:
      'Summarize snippets of answers from multiple sources into a single coherent answer (RAG)/conversational search',
  },
  es_col1_paragraph_05: {
    id: 'sBVGK8',
    defaultMessage: 'Recommended product bundle:',
  },
  es_col1_paragraph_06_01: {
    id: 'VkYlYh',
    defaultMessage: 'A combination of ',
  },
  es_col1_paragraph_06_02: {
    id: 'r4LJFd',
    defaultMessage: 'watsonx Orchestrate, Databases for Elastic',
  },
  es_col1_paragraph_06_03: {
    id: 'lEaoZ1',
    defaultMessage: ', watsonx.ai',
  },
  es_col1_tooltip_01_1: {
    id: 'g0DUKZ',
    defaultMessage: 'Databases for Elastic',
  },
  es_col1_tooltip_01_2: {
    id: '2ix/G4',
    defaultMessage:
      ' provided fast, scalable data access, enabling quick and accurate responses to user queries',
  },
  es_col1_tooltip_02_1: {
    id: 'LPoynT',
    defaultMessage: 'With ',
  },
  es_col1_tooltip_02_2: {
    id: 'MZpQld',
    defaultMessage: 'watsonx.ai',
  },
  es_col1_tooltip_02_3: {
    id: 'UfyNlt',
    defaultMessage:
      ', responses are personalized based on employee roles, ensuring relevant answers',
  },
  es_col2_paragraph_01: {
    id: 'MeQy8/',
    defaultMessage: 'The estimated price for your selection:',
  },
  es_col2_paragraph_02: {
    id: '9oc36G',
    defaultMessage:
      'For less than $13* per user per year, you can get started on generating answers based on disparate sources and formats of information, grounded in trusted enterprise content with full traceability to the source material.',
  },
  es_col2_paragraph_02_1: {
    id: 'CWsaBD',
    defaultMessage: 'For less than ',
  },
  es_col2_paragraph_02_2: {
    id: 'TBJin5',
    defaultMessage: '$13 per user per year',
  },
  es_col2_paragraph_02_3: {
    id: 'iX/8gW',
    defaultMessage:
      ', you can get started on generating answers based on disparate sources and formats of information, grounded in trusted enterprise content with full traceability to the source material',
  },
  es_col2_paragraph_03: {
    id: '8tP6ed',
    defaultMessage: 'Benefits :',
  },
  es_col2_paragraph_04: {
    id: 'HWSCiB',
    defaultMessage:
      '30% reduction in time spent searching documents to find information more quickly',
  },
  es_col2_paragraph_05: {
    id: 'yMW2oy',
    defaultMessage:
      'Increased knowledge worker learning and satisfaction due to reduced search fatigue and more accurate search results',
  },
  es_col2_paragraph_06: {
    id: 'ouVzA5',
    defaultMessage:
      '7-10% Improved productivity from leveraging Generative AI for document search and summarization',
  },
  es_col2_tooltip_01_1: {
    id: 'afi9/u',
    defaultMessage: 'Starting Price offers:',
  },
  es_col2_tooltip_01_2: {
    id: 'DlYvwD',
    defaultMessage:
      'watsonx.ai 14.4M+ Tokens per Month watsonx Orchestrate Essentials Plan for 1000 Monthly Active Users, 2000 Skill Runs',
  },
  es_col2_tooltip_01_3: {
    id: '3rLFCx',
    defaultMessage:
      'Databases for Elastic - Shared, Small, 50GB Disk, Enterprise Plan, 5,000 Document',
  },
  es_col2_tooltip_02_1: {
    id: 'HUZXwP',
    defaultMessage: 'Forrester, The Total Economic Impact',
  },
  es_col2_tooltip_02_2: {
    id: 'QBTSuE',
    defaultMessage: 'TM',
  },
  es_col2_tooltip_02_3: {
    id: 'MfSZoM',
    defaultMessage: ' of IBM Watson Discovery, October 2023',
  },
  es_col2_tooltip_03_1: {
    id: 'eN+ph6',
    defaultMessage:
      'Gartner, How to Calculate Business Value and Cost for Generative AI Use Cases, March 25, 2025',
  },
  something_else_title: {
    id: 'QUiSL4',
    defaultMessage: 'AI solutions advisor for something else',
  },
  se_col1_paragraph_01: {
    id: '8oPf1o',
    defaultMessage: 'Contact Sales',
  },
  se_col1_paragraph_02: {
    id: 'lcDxO1',
    defaultMessage: 'for your custom quote',
  },
  se_col2_paragraph_01: {
    id: 'ERX/rc',
    defaultMessage: 'AI that works',
  },
  se_col2_paragraph_02: {
    id: 'qIMJB2',
    defaultMessage: 'wherever you work',
  },
  se_col2_paragraph_03: {
    id: 'G0J4/o',
    defaultMessage: 'Human Resources',
  },
  se_col2_paragraph_04: {
    id: 'sCTxZL',
    defaultMessage: 'Procurement',
  },
  se_col2_paragraph_05: {
    id: 'c8nvms',
    defaultMessage: 'Sales',
  },
  final_col1_paragraph_01: {
    id: '8oPf1o',
    defaultMessage: 'Contact Sales',
  },
  final_col1_paragraph_02: {
    id: 'lcDxO1',
    defaultMessage: 'for your custom quote',
  },
  final_col1_paragraph_03: {
    id: 'dngWIV',
    defaultMessage: 'Experience the products',
  },
  final_col1_paragraph_04: {
    id: '7DIW6+',
    defaultMessage: 'Learn More',
  },
  take_next_step: {
    id: 'O1pwkK',
    defaultMessage: 'Take next Steps',
  },
  learnMore_subtitle: {
    id: '6SiUee',
    defaultMessage: 'To continue your AI journey, dive into these resources:',
  },
  learnMore_tile01_text: {
    id: 'KNISPv',
    defaultMessage: 'Register for the Digital Labor IDC Spotlight Report',
  },
  learnMore_tile02_text: {
    id: '8sj1i8',
    defaultMessage: 'Know what clients are saying about watsonx',
  },
  learnMore_tile03_text: {
    id: '6cBDhe',
    defaultMessage: 'Integrations',
  },
  learnMore_tile04_text: {
    id: 'EPtWRh',
    defaultMessage: 'Explore interactive demos',
  },
  start_over: {
    id: 'i4joXC',
    defaultMessage: 'Start Over',
  },
  interactive_subtitle: {
    id: 'UpMsQk',
    defaultMessage:
      'Get started with a trial today. Begin with watsonx Orchestrate for a low-code experience building AI Agents and automations or dive into watsonx.ai to build AI Agents and work with LLMs using pro-code tools.',
  },
  interactive_tile01: {
    id: '9aZkSD',
    defaultMessage: 'wxOrchestrate Trial',
  },
  interactive_tile02: {
    id: 't18Rqm',
    defaultMessage: 'wx.ai Trial',
  },
});

export default messages;
